import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      size: "small",
      model: _vm.searchForm
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "姓名"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "name", $$v);
      },
      expression: "searchForm.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "公司名称"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.company_name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "company_name", $$v);
      },
      expression: "searchForm.company_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "类型"
    }
  }, [_c("el-select", {
    on: {
      change: function change($event) {
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.cooperation_type,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "cooperation_type", $$v);
      },
      expression: "searchForm.cooperation_type"
    }
  }, [_c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  }), _c("el-option", {
    attrs: {
      label: "公寓商户",
      value: 1
    }
  }), _c("el-option", {
    attrs: {
      label: "优质民宿",
      value: 2
    }
  }), _c("el-option", {
    attrs: {
      label: "异业合作",
      value: 3
    }
  }), _c("el-option", {
    attrs: {
      label: "广告推广",
      value: 4
    }
  }), _c("el-option", {
    attrs: {
      label: "其他",
      value: 5
    }
  })], 1)], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索")]), _c("el-button", {
    attrs: {
      type: "warning"
    },
    on: {
      click: function click($event) {
        _vm.searchForm = {
          count: 20,
          page: 1,
          cooperation_type: ""
        };
        _vm.getData("search");
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  })], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "用户名",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "user.phone",
      label: "手机",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status == 0 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "danger"
          }
        }, [_vm._v("待处理")]) : _vm._e(), scope.row.status == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          }
        }, [_vm._v("已跟进")]) : _vm._e(), scope.row.status == 2 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "warning"
          }
        }, [_vm._v("已搁置")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "合作类型",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.cooperation_type == 1 ? _c("span", [_vm._v("公寓商户")]) : _vm._e(), scope.row.cooperation_type == 2 ? _c("span", [_vm._v("优质民宿")]) : _vm._e(), scope.row.cooperation_type == 3 ? _c("span", [_vm._v("异业合作")]) : _vm._e(), scope.row.cooperation_type == 4 ? _c("span", [_vm._v("广告推广")]) : _vm._e(), scope.row.cooperation_type == 5 ? _c("span", [_vm._v("其他")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "合作公司",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            width: "300",
            trigger: "click"
          }
        }, [_c("el-form", {
          attrs: {
            "label-width": "80px"
          }
        }, [_c("el-form-item", {
          attrs: {
            label: "合作类型"
          }
        }, [scope.row.cooperation_type == 1 ? _c("span", [_vm._v("公寓商户")]) : _vm._e(), scope.row.cooperation_type == 2 ? _c("span", [_vm._v("优质民宿")]) : _vm._e(), scope.row.cooperation_type == 3 ? _c("span", [_vm._v("异业合作")]) : _vm._e(), scope.row.cooperation_type == 4 ? _c("span", [_vm._v("广告推广")]) : _vm._e(), scope.row.cooperation_type == 5 ? _c("span", [_vm._v("其他")]) : _vm._e()]), _c("el-form-item", {
          attrs: {
            label: "姓名"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.name))])]), _c("el-form-item", {
          attrs: {
            label: "联系方式"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.contact_way))])]), _c("el-form-item", {
          attrs: {
            label: "公司名称"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.company_name))])]), _c("el-form-item", {
          attrs: {
            label: "城市"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.city))])]), _c("el-form-item", {
          attrs: {
            label: "其他说明"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.explain))])])], 1), _c("el-link", {
          attrs: {
            slot: "reference",
            type: "primary"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.company_name))])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "城市",
      prop: "city",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作人",
      prop: "admin_name",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "备注",
      prop: "remark",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.remark_admin_name ? scope.row.remark_admin_name + "：" : "") + " " + _vm._s(scope.row.remark) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "提交时间",
      prop: "created_at",
      width: "80"
    }
  }), _c("el-table-column", {
    staticStyle: {
      overflow: "hidden"
    },
    attrs: {
      label: "操作",
      width: "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.status === 0 ? _c("el-button", {
          staticClass: "wlc-button-succes",
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.setStatus(scope.row, 1);
            }
          }
        }, [_vm._v("跟进")]) : _vm._e(), scope.row.status === 0 ? _c("el-button", {
          staticClass: "wlc-button-warning",
          attrs: {
            type: "text",
            size: "mini"
          },
          on: {
            click: function click($event) {
              return _vm.setStatus(scope.row, 2);
            }
          }
        }, [_vm._v("搁置")]) : _vm._e(), _c("el-button", {
          attrs: {
            size: "mini",
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.setRemarkDialog(scope.row);
            }
          }
        }, [_vm._v(" 备注 ")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.count,
      "current-page": _vm.searchForm.page,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "备注",
      width: "300px",
      visible: _vm.remarkDialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.remarkDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.setRemark.apply(null, arguments);
      }
    },
    model: {
      value: _vm.remarkValue,
      callback: function callback($$v) {
        _vm.remarkValue = $$v;
      },
      expression: "remarkValue"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.setRemark
    }
  }, [_vm._v(" 确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };